import React, { Component } from "react"
import { Link } from "gatsby"

import { fit, smartCrop } from "util/imgResize"

import styles from "./styles.module.less"

export default class Grid extends Component {
  render() {
    let brakePoints = [350, 500, 750]

    const posts = this.props.posts
    const postLinks = posts.map(post => (
      <li key={post.slug}>
        <Link to={post.slug}>
          <h2 className="is-size-2">{post.title}</h2>
        </Link>
      </li>
    ))

    return (
      <div className={styles.container}>
        <div className={styles.newContainer}>
          {/* <Masonry brakePoints={brakePoints}> */}
          {posts.map(post => (
            <Tile
              link={post.slug}
              key={post.slug}
              title={post.title}
              description={post.description}
              previewImage={post.previewImage}
            />
          ))}
          {/* </Masonry> */}
        </div>
      </div>
    )
  }
}

const Tile = ({ src, title, link, previewImage, description, key }) => {
  const croppedPreview = smartCrop(previewImage, 242, 396, "jpeg")
  return (
    <div className={styles.tile}>
      <Link to={link}>
        <div className={styles.imgFit}>
          <img className={styles.img} src={croppedPreview} />
        </div>

        {/* <Img className={styles.img} fixed={previewImage} /> */}
        <div className={styles.desc}>
          <h3 className={styles.title}>{title}</h3>
          <p className={styles.description}>{description}</p>
        </div>
      </Link>
    </div>
  )
}

// class Masonry extends React.Component {
//   constructor(props) {
//     super(props)
//     this.state = { columns: 1 }
//     this.msnRef
//     this.onResize = this.onResize.bind(this)
//   }
//   componentDidMount() {
//     this.onResize()
//     window.addEventListener("resize", this.onResize)
//   }

//   getColumns(w) {
//     return (
//       this.props.brakePoints.reduceRight((p, c, i) => {
//         return c < w ? p : i
//       }, this.props.brakePoints.length) + 1
//     )
//   }

//   onResize() {
//     const columns = this.getColumns(this.msnRef.offsetWidth)
//     if (columns !== this.state.columns) {
//       this.setState({ columns: columns })
//     }
//   }

//   mapChildren() {
//     let col = []
//     const numC = this.state.columns
//     for (let i = 0; i < numC; i++) {
//       col.push([])
//     }
//     return this.props.children.reduce((p, c, i) => {
//       p[i % numC].push(c)
//       return p
//     }, col)
//   }

//   render() {
//     let myRef = el => (this.msnRef = el)
//     return (
//       <div className={styles.masonry} ref={myRef}>
//         {this.mapChildren().map((col, ci) => {
//           return (
//             <div className={styles.column} key={ci}>
//               {col.map((child, i) => {
//                 return <div key={i}>{child}</div>
//               })}
//             </div>
//           )
//         })}
//       </div>
//     )
//   }
// }
